const StepsIcon = () => {
	return (
		<svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0.625 10.625H3.95833V7.29167H7.29167V3.95833H10.625V0.625H13.9583"
				stroke="var(--secondary-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default StepsIcon;
